import { NavLink } from "react-router-dom";
import moment from "moment";
import Dashboard from "../dashboard/Dashboard";
import Tabs from "./components/Tabs";
import GuardianDetails from "./components/GuardianDetails";
import BasicInfo from "../../components/basic-info/BasicInfo";
import ChipList from "../../components/chip-list/ChipList";
import ProfilePhoto from "../../components/profile-photo/ProfilePhoto";

import "../../components/generalComponents.scss";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IStudentDetail, studentDetails } from "../../services/student.service";
import showToast from "../../utils/show.toast";

export default function StudentDetail() {
  const [studentDetail, setStudentDetail] = useState<IStudentDetail>({
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    countryOfOrigin: "",
    countryOfResidence: "",
    email: "",
    languagesSpoke: [],
    Interests: [],
    profilePictureUrl: "",
  });

  const { studentId } = useParams();
  const getRegisteredStudents = async (userId: string) => {
    const request = await studentDetails(userId);
    if (request.status !== "success") {
      showToast("Apologies, error occured fetching student details", false);
      return;
    }
    setStudentDetail(request.result);
  };

  useEffect(() => {
    getRegisteredStudents(studentId as string);
  }, []);

  return (
    <Dashboard pageTitle="Registered Student">
      <Tabs>
        <div className="section">
          <div className="profile-photo-and-names">
            <ProfilePhoto imageUrl={studentDetail.profilePictureUrl} />

            <div className="first-and-last-name">
              <BasicInfo title="First Name" data={studentDetail.firstName} />
              <BasicInfo title="Last Name" data={studentDetail.lastName} />
            </div>
          </div>

          <div className="more-profile-info">
            <BasicInfo
              title="Date of Birth"
              data={moment(studentDetail.dateOfBirth).format(
                "ddd, Do MMMM, YYYY"
              )}
            />
            <BasicInfo title="Gender" data={studentDetail.gender} />
            <BasicInfo
              title="Nationality"
              data={studentDetail.countryOfOrigin}
            />
            <BasicInfo
              title="Currently Living in"
              data={studentDetail.countryOfResidence}
            />
            <BasicInfo title="Email Address" data={studentDetail.email} />

            <ChipList
              title="Spoken Language(s)"
              data={studentDetail.languagesSpoke}
            />
            <ChipList title="Interests" data={studentDetail.Interests} />
          </div>
        </div>

        <GuardianDetails />
      </Tabs>
    </Dashboard>
  );
}
